/**
 * Historial
 * Avances de actividad
 *
 */
import React from 'react'
import { Table, Button, Icon, Popconfirm, DatePicker, InputNumber, } from 'antd'
import numeral from 'numeral'
import moment from 'moment'
import { Cell } from '../../../../components'
import Api from '../../../../Api'
import Exception from '../../../../Exception'

export class HistorialAvancesActividad extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      loading: false,
    }
  }

  /**
   * componentDidMount
   *
   */
  componentDidMount() {
    if (this.props.actividadId) {
      this.fetch(this.props.actividadId)
    }
  }

  /**
   * componentWillReceiveProps
   *
   * @param {Object} newProps
   */
  componentWillReceiveProps(newProps) {
    if (newProps.actividadId && this.props.actividadId !== newProps.actividadId) {
      this.fetch(newProps.actividadId)
    }
  }

  /**
   * fetch
   *
   * @param {number} actividadId
   */
  fetch = async (actividadId) => {
    try {
      this.setState({ loading: true })

      const { data: avances } = await Api.query({
        model: 'CmrAvance',
        include: [{
          as: 'fase',
          required: true,
          attributes: ['sNombre'],
        }],
        where: {
          iIdActividad: actividadId,
          iActivo: true,
        },
        order: [['dFecha', 'DESC']],
      })

      this.setState({
        loading: false,
        data: avances,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * saveKey
   *
   * @param {string} key
   * @param {string | number} value
   */
  saveKey = (id, key, value) => {
    this.setState({ loading: true })

    const mutation = {
      model: 'CmrAvance',
      id: id,
      values: { [key]: value },
    }

    Api.post('/kernel/mutator', { items: [mutation] })
      .then(() => {
        this.setState({
          loading: false,
          data: this.state.data.map(e => e.iId !== id ? e :
            ({
              ...e,
              [key]: value,
            })
          )
        })
        this.props.onSave && this.props.onSave(id, key, value)
      })
      .catch(err => {
        this.setState({ loading: false })
        Exception.load(err).show()
      })
  }

  /**
   * remove
   *
   * @param {number} id
   */
  remove = (id) => {
    this.setState({ loading: true })

    const mutation = {
      model: 'CmrAvance',
      id: id,
      values: { iActivo: false },
    }

    Api.post('/kernel/mutator', { items: [mutation] })
      .then(() => {
        this.setState({
          loading: false,
          data: this.state.data.filter(e => e.iId !== id),
        })

        this.props.onRemove && this.props.onRemove()
      })
      .catch(err => {
        this.setState({ loading: false })
        Exception.load(err).show()
      })
  }

  /**
   * render
   *
   */
  render() {
    const totalPonderado = this.state.data.reduce(
      (sum, item) => sum + item.dVolumen * 1, 0
    )

    const renderFecha = (value, record) => (
      record.iId !== this.props.editingAvanceId ?
      moment(value).format('YYYY-MM-DD') :
      <DatePicker
        placeholder='Fecha'
        showTime={false}
        mode='date'
        size='small'
        format='YYYY-MM-DD'
        defaultValue={moment(value, 'YYYY-MM-DD')}
        style={{ fontSize: 'inherit' }}
        onChange={(value) => value ? this.saveKey(record.iId, 'dFecha', value.format('YYYY-MM-DD')) : null}
      />
    )

    const renderVolumen = (value, record) => (
      record.iId !== this.props.editingAvanceId ?
        numeral(value).format('0,0.00') :
        <InputNumber
          autoFocus
          placeholder='Volumen AV'
          size='small'
          defaultValue={value}
          onKeyDown={e => e.keyCode === 13 ? this.saveKey(record.iId, 'dVolumen', e.target.value * 1) : null}
        />
    )

    return (
      <Table
        style={{ flex: 1 }}
        rowKey='iId'
        size='small'
        dataSource={this.state.data.concat([
            {
              fase: { sNombre: 'TOTAL' },
              dVolumen: totalPonderado,
            }
          ])
        }
        loading={this.state.loading}
        pagination={false}
        title={this.props.tableTitle}

        columns={Cell.buildList([
          { width: '20%', title: 'FECHA', dataIndex: 'dFecha', render: renderFecha },
          { width: '20%', title: 'FASE', dataIndex: 'fase.sNombre' },
          { width: '20%', title: 'VOLUMEN AV.', dataIndex: 'dVolumen', render: renderVolumen },
          { width: '10%', title: 'PORCENTAJE AV.', dataIndex: 'dPorcentaje', render: (value) => value ? numeral(value).format('0,0.00%') : null },
          { width: '20%', title: 'IMPORTE AV.', dataIndex: 'dImporte', render: (value) => value ? numeral(value).format('$0,0.00') : null },
          { width: '10%', title: (<Icon type='block' style={{ fontSize: 20 }} />), dataIndex: 'dFecha', render: (_, { iId }) => iId ? (
            <span>
              <Button
                style={{ marginRight: 7 }}
                icon={this.props.editingAvanceId !== iId ? 'edit' : 'undo'}
                onClick={() => this.props.onEdit(this.props.editingAvanceId !== iId ? iId : null)}
              />

              <Popconfirm
                title='¿Borrar avance?'
                onConfirm={() => this.remove(iId)}
                children={<Button icon='delete' />}
              />
            </span>
          ) : null},
        ])}
      />
    )
  }
}
